export interface TrendItem {
  id: string;
  rank: number;
  title: string;
  heat: number;
  category: string;
  delta: 'up' | 'down' | 'new' | 'flat';
}

export interface LiveReport {
  id: string;
  tag: string;
  title: string;
  summary: string;
  time: string;
  views: string;
  image: string;
}

export interface FeedItem {
  id: string;
  tag: string;
  title: string;
  summary: string;
  views: string;
  comments: string;
  time: string;
  image: string;
  read: string;
}

export interface DeepRead {
  id: string;
  tag: string;
  title: string;
  summary: string;
  wordCount: string;
  read: string;
  time: string;
  image: string;
}

export const trendItems: TrendItem[] = [
  { id: 't1', rank: 1, title: '年度旗舰手机发布会“突发事件”全记录', heat: 982, category: '科技', delta: 'up' },
  { id: 't2', rank: 2, title: '知名网红茶饮门店排长队被质疑雇人', heat: 917, category: '消费', delta: 'up' },
  { id: 't3', rank: 3, title: '大型综艺收官夜现场名场面逐帧复盘', heat: 864, category: '娱乐', delta: 'flat' },
  { id: 't4', rank: 4, title: '电商大促优惠券“看不懂”引发全网吐槽', heat: 802, category: '民生', delta: 'up' },
  { id: 't5', rank: 5, title: '头部物流公司凌晨回应配送延迟风波', heat: 731, category: '职场', delta: 'down' },
  { id: 't6', rank: 6, title: '国产芯片新架构发布现场反响两极', heat: 664, category: '科技', delta: 'new' },
  { id: 't7', rank: 7, title: '某平台会员涨价后老用户集体讨说法', heat: 588, category: '消费', delta: 'down' },
  { id: 't8', rank: 8, title: '跨城直播带货首秀中途设备故障还原', heat: 452, category: '电商', delta: 'new' },
];

export const liveReports: LiveReport[] = [
  {
    id: 'l1',
    tag: '现场直击',
    title: '凌晨发布会后记者会实录：主理人现场回应定价争议',
    summary: '新品公布价格的一刻，现场倒吸一口凉气。主理人在随后的记者会上如何回应“定价过高”的质疑？我们逐字还原了全程问答。',
    time: '今天 02:48',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20crowded%20tech%20product%20launch%20stage%20with%20spotlights%2C%20press%20conference%20podium%2C%20journalists%20and%20camera%20flashes%2C%20warm%20cream%20background%2C%20coral%20red%20melon%20green%20and%20amber%20palette%2C%20magazine%20infographic%20style%2C%20textured%20grain%2C%20no%20text&width=1200&height=800&seq=live-a1&orientation=landscape',
  },
  {
    id: 'l2',
    tag: '现场直击',
    title: '万人演唱会散场夜：粉丝灯牌拼成的巨型应援有多震撼',
    summary: '散场后的场馆外，保安与“灯海”上演拉扯名场面。我们采访了多位蹲守到凌晨的粉丝，还原这场持续五小时的集体情绪。',
    time: '今天 00:12',
    views: '96.3万',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20massive%20outdoor%20concert%20crowd%20holding%20glowing%20light%20sticks%2C%20night%20scene%20with%20warm%20spotlights%2C%20stylized%20audience%20silhouettes%2C%20warm%20cream%20melon%20green%20coral%20and%20amber%20palette%2C%20magazine%20infographic%20style%2C%20textured%20grain%2C%20no%20text&width=1200&height=800&seq=live-a2&orientation=landscape',
  },
  {
    id: 'l3',
    tag: '现场直击',
    title: '网红店开业首日实拍：从开门到断货只用了90分钟',
    summary: '门店还没开门，门口已经绕了三圈。开业90分钟宣告售罄，我们记录了黄牛、代购与普通顾客之间微妙的角力。',
    time: '昨天 22:40',
    views: '74.1万',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20long%20queuing%20crowd%20outside%20a%20stylish%20beverage%20store%20opening%20day%2C%20bunting%20and%20awnings%2C%20eager%20customers%20holding%20phones%2C%20warm%20cream%20coral%20and%20amber%20palette%2C%20magazine%20infographic%20style%2C%20textured%20grain%2C%20no%20text&width=1200&height=800&seq=live-a3&orientation=landscape',
  },
];

export const feedItems: FeedItem[] = [
  {
    id: 'f1',
    tag: '科技',
    title: '网友扒出新品预售页藏着三个“小字条款”，购买前必看',
    summary: '预售页拉到底，才发现优惠幅度与退货规则的边界条件。这届网友化身“条款翻译官”，逐条拆解其中的信息差。',
    views: '32.4万',
    comments: '4821',
    time: '2小时前',
    read: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20large%20magnifying%20glass%20over%20a%20fine%20print%20contract%20document%20and%20shopping%20cart%2C%20warm%20cream%20background%2C%20coral%20red%20melon%20green%20amber%20palette%2C%20magazine%20infographic%20style%2C%20textured%20grain%2C%20no%20text&width=800&height=600&seq=feed-b1&orientation=landscape',
  },
  {
    id: 'f2',
    tag: '消费',
    title: '同一款产品双平台价差近四成，比价博主实测后吵翻了',
    summary: '同一链接、同一品牌，两个平台到手价却差出一顿火锅钱。比价博主们连夜实测，网友评论区的看法却两极分化。',
    views: '28.9万',
    comments: '3654',
    time: '4小时前',
    read: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20two%20shopping%20price%20tags%20being%20compared%20with%20a%20balance%20scale%20and%20calculator%20in%20the%20middle%2C%20warm%20cream%20background%2C%20coral%20red%20and%20melon%20green%20accent%2C%20magazine%20infographic%20style%2C%20no%20text&width=800&height=600&seq=feed-b2&orientation=landscape',
  },
  {
    id: 'f3',
    tag: '娱乐',
    title: '综艺里那顿“迟到的盒饭”，为什么能冲上热搜一整天',
    summary: '一档慢综艺里嘉宾因为道具盒饭闹出的小插曲，被网友反复解读成职场生存隐喻。吃瓜之余，我们聊聊它为什么能火。',
    views: '25.1万',
    comments: '2987',
    time: '6小时前',
    read: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20cozy%20variety%20show%20set%20with%20a%20steaming%20lunch%20box%2C%20camera%20and%20stage%20lights%2C%20people%20watching%20on%20a%20screen%2C%20warm%20cream%20amber%20and%20coral%20palette%2C%20magazine%20infographic%20style%2C%20no%20text&width=800&height=600&seq=feed-b3&orientation=landscape',
  },
  {
    id: 'f4',
    tag: '职场',
    title: '一封“史上最短”离职邮件疯传，评论区变成职场吐槽大会',
    summary: '短短一行字的离职理由，却在打工人中间炸开了锅。有人直呼痛快，也有人提醒后果自负，背后是长久积压的情绪。',
    views: '22.7万',
    comments: '5320',
    time: '9小时前',
    read: '3分钟',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20an%20office%20worker%20handing%20in%20a%20resignation%20letter%20at%20a%20desk%20with%20a%20backpack%20and%20exit%20sign%2C%20warm%20cream%20melon%20green%20and%20coral%20palette%2C%20magazine%20infographic%20style%2C%20no%20text&width=800&height=600&seq=feed-b4&orientation=landscape',
  },
  {
    id: 'f5',
    tag: '民生',
    title: '小区停车新规实施首日：业主群从“吵翻”到“真香”只用了48小时',
    summary: '新规刚出时评论区一片哀嚎，执行两天后画风突变。我们走进这个小区，看一次教科书式的公共决策如何逆转口碑。',
    views: '19.6万',
    comments: '2140',
    time: '11小时前',
    read: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20residential%20compound%20parking%20lot%20with%20cars%2C%20signage%20and%20residents%20discussing%2C%20warm%20cream%20green%20and%20amber%20palette%2C%20magazine%20infographic%20style%2C%20no%20text&width=800&height=600&seq=feed-b5&orientation=landscape',
  },
  {
    id: 'f6',
    tag: '电商',
    title: '主播“翻车”后的道歉直播，弹幕里的真实态度你看懂了吗',
    summary: '一场道歉直播的弹幕，比正片还精彩。有人说诚意到了，有人列出“打脸清单”，主播的带货生态迎来分水岭。',
    views: '16.8万',
    comments: '3091',
    time: '13小时前',
    read: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20live%20streaming%20host%20apologizing%20on%20camera%20with%20a%20wall%20of%20floating%20viewer%20comments%20behind%2C%20warm%20cream%20coral%20and%20melon%20green%20palette%2C%20magazine%20infographic%20style%2C%20no%20text&width=800&height=600&seq=feed-b6&orientation=landscape',
  },
];

export const deepReads: DeepRead[] = [
  {
    id: 'd1',
    tag: '深扒还原',
    title: '从一条热搜到全网共鸣：我们还原一次“离谱促销”的完整传播链',
    summary: '一条看似荒诞的促销规则，如何一步步从论坛帖发酵成全网热搜？我们拉出时间线，拆解情绪如何被放大、被传播、又被收割。',
    wordCount: '约3200字',
    read: '12分钟',
    time: '昨天',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20visual%20timeline%20of%20a%20trending%20topic%20spreading%20across%20social%20media%20nodes%2C%20speech%20bubbles%20and%20magnifying%20glasses%2C%20warm%20cream%20coral%20red%20and%20melon%20green%20palette%2C%20large%20format%20magazine%20infographic%20style%2C%20no%20text&width=1600&height=900&seq=deep-c1&orientation=landscape',
  },
  {
    id: 'd2',
    tag: '实况复盘',
    title: '一场“全网围观”的品牌危机：48小时声明进化史逐字复盘',
    summary: '从一句冷冰冰的“内部沟通中”，到最终发布的长篇说明，48小时里声明措辞经历了怎样的迭代？我们用逐字对比还原公关现场。',
    wordCount: '约4500字',
    read: '18分钟',
    time: '2天前',
    image: 'https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20an%20office%20board%20covered%20with%20draft%20statements%2C%20sticky%20notes%2C%20timeline%20and%20red%20pens%2C%20crisis%20communication%20concept%2C%20warm%20cream%20amber%20and%20coral%20palette%2C%20large%20magazine%20infographic%20style%2C%20no%20text&width=1600&height=900&seq=deep-c2&orientation=landscape',
  },
];

export const categoryTabs: string[] = ['全部', '科技', '娱乐', '消费', '职场', '民生', '电商'];